// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__MXLw4","errorLogs":"styles_errorLogs__1jcO1"};